<div class="animated fadeInRight">
  <!-- MENU DE TITULOS -->
  <app-lfsa-card-v2 [innTemplateButton]="innTemplateButton" [innTemplate]="enviarTemplateEdit"
                    [modulo]="DAT_TITULOS.modulo" [tituloCard]="DAT_TITULOS.titulo" [titulo]="DAT_TITULOS.titulo">
  </app-lfsa-card-v2>
  <!-- MENU DE TITULOS -->

  <!-- OPCIONES LATERAL IZQUIERDO -->
  <ng-template #innTemplateButton>
    <div class="col-md-6 mb-2">
      <div class="pagetitle">
        <div class="btn-group-justified btn-group" style="float: right;">
          <button (click)="nuevo()" class="btn btn-outline-success">
            <i aria-hidden="true" class="fa fa-plus"></i>
            {{DAT_BTNS.nuevo}}
          </button>
        </div>
      </div>
    </div>
  </ng-template>
  <!-- OPCIONES LATERAL IZQUIERDO -->

  <!-- GRILLA -->
  <ng-template #enviarTemplateEdit>
    <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
    <ag-grid-angular #agGrid (gridReady)="onGridReady($event)" [class]="DAT_AG_GRID.class" [columnDefs]="columnDefs"
                     [floatingFilter]="true" [frameworkComponents]="frameworkComponents" [id]="DAT_AG_GRID.id"
                     [ngStyle]="DAT_AG_GRID.style" [paginationPageSize]="DAT_AG_GRID.paginacion" [pagination]="true"
                     [rowData]="rowData">
      [rowSelection]="'single'"
    </ag-grid-angular>
  </ng-template>
  <!-- GRILLA -->
</div>

<!-- MODAL -->
<app-lfsa-modal [classModal]="'modal-lg'" [idButton]="'abrirModal'" [idClose]="'cerrarModal'" [innTemplate]="abrirModal"
                [titulo]="tituloModal"></app-lfsa-modal>
<ng-template #abrirModal>
  <div class="container-fluid">
    <form [formGroup]="agregarForm" mat-dialog-content>
      <div class="row">
        <div class="row">
          <div *ngIf="!isCreate" class="form-group col-12">
            <app-lfsa-input [control]="this.agregarForm.get('id')" [id]="'id'" [label]="'Id'" formControlName="id"
                            readonly type="number"></app-lfsa-input>
            <small *ngIf="this.agregarForm.get('id')?.hasError('pattern')" class="letrasDanger">*Solo
              números y punto, hasta 4 decimales. Ej: 12.3456</small>
          </div>

          <div class="form-group col-12">
            <app-lfsa-input [control]="this.agregarForm.get('descripcion')" [id]="'descripcion'" [label]="'Descripción'"
                            formControlName="descripcion"
                            type="text"></app-lfsa-input>
            <small *ngIf="this.agregarForm.get('descripcion')?.hasError('pattern')" class="letrasDanger">*Solo
              números y punto,
              hasta 4 decimales. Ej: 12.3456</small>
          </div>
          <div class="col-6">
            <div class="mb-2">
              <label for="">Proveedor</label>
              <input (change)="onChangeProveedor($event);" (keydown)="noWhitespace($event)"
                     (keyup)="onChangeProveedor($event);this.agregarForm.controls['proveedor'].value.length > 0 ? onChangeValues() : ''"
                     autocomplete="off" class="form-control"
                     formControlName="proveedor" name="proveedor"
                     type="text">
              <div *ngIf="proveeControl?.hasError('required') && proveeControl.touched" class="text-danger">
                <small>*Este campo es requerido</small>
              </div>
              <div *ngIf="proveedorInvalido" class="text-danger">
                <small>*Este proveedor es inválido</small>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="mb-2">
              <label for="">Desc. Proveedor</label>
              <input autocomplete="off" class="form-control" formControlName="despro" name="despro" readonly
                     type="text">
            </div>
          </div>
          <div class="col-12">
            <label>Estado</label>
            <select class="form-control" formControlName="estado" name="estado">
              <option value="0">Activo</option>
              <option value="1">Inactivo</option>
            </select>
            <!-- <div *ngIf="formBascula.controls['estado'].invalid && (formBascula.controls['estado'].dirty || formBascula.controls['estado'].touched)"
                            class="text-danger">
                            <small>
                                <div *ngIf="formBascula.controls['estado'].errors">
                                    Este campo es requerido.
                                </div>
                            </small>
                        </div> -->
          </div>
        </div>

        <!-- (ejecutarEvento)="getCuentasContables()" -->
        <app-lfsa-botones-formulario (devolverAccion)="acciones( $event )" [formularioValido]="agregarForm.invalid"
                                     [loading]="loading" [textBoton]="'Guardar'"
                                     class="row mt-3">
        </app-lfsa-botones-formulario>
      </div>
    </form>
  </div>
</ng-template>
<!-- END MODAL -->
